import { useState } from "react";
import axios from "axios";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ClientPortalLogin() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/client-portal/request`, { email });
      setSent(true);
    } catch {
      // Keep silent — endpoint intentionally returns ok to avoid enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAF7] p-6">
      <div className="bg-white border border-neutral-200 p-8 max-w-md w-full">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 flex items-center justify-center" style={{ background: "#0F3D3A" }}>
            <Mail className="h-5 w-5 text-white" />
          </div>
          <div>
            <div className="mono-label">Portale cliente</div>
            <h1 className="font-display text-2xl font-medium mt-0.5">Accedi alla tua area</h1>
          </div>
        </div>

        {sent ? (
          <div className="border-l-2 border-green-400 bg-green-50 p-4" data-testid="portal-sent">
            <div className="flex items-center gap-2 text-green-900 font-medium"><CheckCircle2 className="h-4 w-4" /> Email inviata</div>
            <p className="text-sm text-green-800 mt-1">Se l'indirizzo è associato a una pratica, riceverai a breve una email con un link di accesso valido 24 ore. Controlla anche lo spam.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="portal-form">
            <p className="text-sm text-neutral-600">Inserisci la email registrata dallo studio. Ti invieremo un link di accesso valido 24 ore, senza password.</p>
            <div>
              <label className="mono-label">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="portal-email"
                autoFocus
                className="mt-1 w-full border border-neutral-300 px-3 py-2.5 text-sm focus:outline-none focus:border-neutral-800"
              />
            </div>
            <button
              type="submit"
              disabled={loading || !email}
              data-testid="portal-submit"
              className="w-full py-2.5 text-white text-sm font-medium disabled:opacity-50"
              style={{ background: "#0F3D3A" }}
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin inline" /> : "Invia link di accesso"}
            </button>
          </form>
        )}

        <div className="mt-8 pt-6 border-t border-neutral-200 text-xs text-neutral-500 text-center">
          Non ricevi il link? Contatta direttamente lo studio.
        </div>
      </div>
    </div>
  );
}
